import React from "react"
import { TableCell, TableSortLabel } from "@mui/material"
import TableHeaderText from "./TableHeaderText"

export type Order = "asc" | "desc"

export interface SortableTableHeaderCellProps<T extends string> {
  label: string
  orderBy: T
  order: Order
  property: T
  onRequestSort: (property: T) => void
  leftPadding?: boolean
}

const SortableTableHeaderCell = <T extends string>({
  label,
  orderBy,
  order,
  property,
  onRequestSort,
  leftPadding
}: SortableTableHeaderCellProps<T>) => {
  return (
    <TableCell
      sx={leftPadding ? { pl: { xs: 2, md: 6 } } : undefined}
      sortDirection={orderBy === property ? order : false}
    >
      <TableSortLabel
        active={orderBy === property}
        direction={orderBy === property ? order : "asc"}
        onClick={() => onRequestSort(property)}
      >
        <TableHeaderText>{label}</TableHeaderText>
      </TableSortLabel>
    </TableCell>
  )
}

export default SortableTableHeaderCell
